import { render, staticRenderFns } from "./InputTextWithLocalSuggestions.vue?vue&type=template&id=68b0128f"
import script from "./InputTextWithLocalSuggestions.vue?vue&type=script&lang=js"
export * from "./InputTextWithLocalSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports